<template>
  <div class="vue-wrapper">
    <!--TheLoader :active="loading"/-->
    <div class="content-container flex-row">
      <div class="sidebar left fixed subnav show-for-large">
        <div class="fixed-container">
          <scrollactive active-class="active" :highlightFirstItem="true" :offset="106" :duration="500" :modifyUrl="false" bezier-easing-value="0.455,0.03,0.515,0.955">
            <ul id="form-scroll-menu">
              <li><a id="btn-kunde-edit-section-0" href="#kunde-edit-section-0" class="scrollactive-item active" :class="{'error': sectionErrors.hasOwnProperty('kunde-edit-section-0')}">Innstillinger <span class="count" v-if="sectionErrors.hasOwnProperty('kunde-edit-section-0')">{{sectionErrors['kunde-edit-section-0']}}</span></a></li>
              <li><a id="btn-kunde-edit-section-1" href="#kunde-edit-section-1" class="scrollactive-item" v-if="form.Bedrift" :class="{'error': sectionErrors.hasOwnProperty('kunde-edit-section-1')}">Bedrift <span class="count" v-if="sectionErrors.hasOwnProperty('kunde-edit-section-1')">{{sectionErrors['kunde-edit-section-1']}}</span></a></li>
              <li><a id="btn-kunde-edit-section-2" href="#kunde-edit-section-2" class="scrollactive-item" :class="{'error': sectionErrors.hasOwnProperty('kunde-edit-section-2')}">Personalia <span class="count" v-if="sectionErrors.hasOwnProperty('kunde-edit-section-2')">{{sectionErrors['kunde-edit-section-2']}}</span></a></li>
              <li><a id="btn-kunde-edit-section-3" href="#kunde-edit-section-3" class="scrollactive-item" :class="{'error': sectionErrors.hasOwnProperty('kunde-edit-section-3')}">Fakturaadresse <span class="count" v-if="sectionErrors.hasOwnProperty('kunde-edit-section-3')">{{sectionErrors['kunde-edit-section-3']}}</span></a></li>
              <li><a id="btn-kunde-edit-section-4" href="#kunde-edit-section-4" class="scrollactive-item" :class="{'error': sectionErrors.hasOwnProperty('kunde-edit-section-4')}">Legitimasjon <span class="count" v-if="sectionErrors.hasOwnProperty('kunde-edit-section-4')">{{sectionErrors['kunde-edit-section-4']}}</span></a></li>
              <li><a id="btn-kunde-edit-section-5" href="#kunde-edit-section-5" class="scrollactive-item" :class="{'error': sectionErrors.hasOwnProperty('kunde-edit-section-5')}">Økonomi <span class="count" v-if="sectionErrors.hasOwnProperty('kunde-edit-section-5')">{{sectionErrors['kunde-edit-section-5']}}</span></a></li>
              <li><a id="btn-kunde-edit-section-6" href="#kunde-edit-section-6" class="scrollactive-item" :class="{'error': sectionErrors.hasOwnProperty('kunde-edit-section-6')}">Vin <span class="count" v-if="sectionErrors.hasOwnProperty('kunde-edit-section-6')">{{sectionErrors['kunde-edit-section-6']}}</span></a></li>
              <li><a id="btn-kunde-edit-section-7" href="#kunde-edit-section-7" class="scrollactive-item" :class="{'error': sectionErrors.hasOwnProperty('kunde-edit-section-7')}">Know Your Customer<span class="count" v-if="sectionErrors.hasOwnProperty('kunde-edit-section-7')">{{sectionErrors['kunde-edit-section-7']}}</span></a></li>
            </ul>
          </scrollactive>
        </div>
      </div>

      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">
          <div class="scroll-section" id="kunde-edit-section-0">
            <h2>Innstillinger</h2>
            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-6">
                  <label>Kontotype</label>
                  <div class="radio-button-container">
                    <ul>
                      <li>
                        <input id="Bedrift-0" name="Bedrift" type="radio" v-model="form.Bedrift" v-bind:value="false">
                        <label for="Bedrift-0">Privat</label>
                      </li>
                      <li>
                        <input id="Bedrift-1" name="Bedrift" type="radio" v-model="form.Bedrift" v-bind:value="true">
                        <label for="Bedrift-1">Bedrift</label>
                      </li>
                    </ul>
                  </div>
                </div>

                <TheSelectInput v-model="form.Brukerid" containerClassName="cell small-12 medium-6" label="Kundeansvarlig" name="Brukerid" :items="instillinger.bruker"/>
                <TheSelectInput v-model="form.Landkode" containerClassName="cell small-12 large-6" label="Land" name="Landkode" :items="instillinger.land">
                  <span slot="option" slot-scope="props">
                    {{props.option.val}}
                    <span v-if="props.option.key && props.option.val !== 'Laster...'">[{{props.option.key}}]</span>
                  </span>
                </TheSelectInput>
                <TheSelectInput v-model="form.Sprak" containerClassName="cell small-12 large-6" label="Språk" name="Sprak" :items="instillinger.sprak"/>

                <div class="cell">
                  <ul class="switch-list">
                    <!-- <TheSwitchListSwitchInput v-model="VinKunde" labelTrue="Vin kunde" labelFalse="Vin kunde" /> -->
                    <TheSwitchListSwitchInput v-model="form.Arsavtale" labelTrue="Årsavtale" labelFalse="Årsavtale" />
                    <TheSwitchListSwitchInput v-model="form.Leverandor" labelTrue="Leverandør" labelFalse="Leverandør" trueValue="T" falseValue="F"/>
                    <TheSwitchListSwitchInput v-model="form.Sperret" labelTrue="Sperret" labelFalse="Sperret" trueValue="T" falseValue="F" :disabled="!hasSperretAccess"/>
                    <TheSwitchListSwitchInput v-model="form.SendLagerleieinfo" labelTrue="Denne kunden skal ha lagerleie" labelFalse="Denne kunden skal ha lagerleie" :trueValue="1" :falseValue="0"/>
                    <TheSwitchListSwitchInput v-model="form.force_twentyfourseven" labelTrue="Force to 24SO" labelFalse="Force to 24SO"/>

                    <TheSwitchListSwitchInput v-model="form.Katalog" labelTrue="Denne kunde skal ha katalog" labelFalse="Denne kunde skal ha katalog" :trueValue="1" :falseValue="0"/>
                    <li>
                      <div class="grid-x">
                        <div class="cell large-6" style="padding: 0.75rem 0 0 0;">
                          <label style="font-size: 0.75rem;">
                            Hvorfor katalog
                            <span style="font-size: 0.7rem;" class="opacity-60" v-if="form.KatalogInfo_endret_av"><br>Endret av: {{form.KatalogInfo_endret_av}} / {{form.KatalogInfo_endret_tid | avantidatetime}}</span>
                          </label>
                        </div>
                        <div class="cell large-6" style="padding: 0.6rem 0 0 0;">
                          <TheTextInput containerClassName="" :hideLabel="true" inputLabel="" name="KatalogInfo" :required="!!form.Katalog" v-validate="katalogInfoRule" v-model.trim="form.KatalogInfo" maxlength="255"/>
                          <!-- <div v-if="form.KatalogInfo_endret_av" style="text-align: left; margin-bottom: 6px;">
                            <em style="font-size: 0.7rem;">Katalog, sist endret av: {{form.KatalogInfo_endret_av}} / {{form.KatalogInfo_endret_tid | avantidatetime}}</em>
                          </div> -->
                        </div>
                      </div>
                    </li>
                    <TheSwitchListSwitchInput v-model="form.Vip" labelTrue="VIP-Kunde" labelFalse="VIP-Kunde" disabled/>
                  </ul>
                </div>
              </div>
            </fieldset>
          </div>

          <!-- Start: Bedrift == true -->
          <div class="scroll-section" id="kunde-edit-section-1" v-show="form.Bedrift">
            <h2>Bedrift</h2>
            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <TheTextInput containerClassName="cell large-6" label="Frimanavn" name="FirmaNavn" v-model.trim="form.FirmaNavn" maxlength="100" :required="form.Bedrift" v-validate="firmaNavnRule"/>
                <TheTextInput containerClassName="cell large-6" label="Org nr" name="Mvanr" v-model.trim="form.Mvanr" maxlength="25" v-validate="'max:25'"/>
              </div>
            </fieldset>
          </div>
          <!-- End: Bedrift == true -->

          <div class="scroll-section" id="kunde-edit-section-2">
            <h2>Personalia</h2>
            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <TheTextInput containerClassName="cell small-3 large-2" label="Tittel" name="Tittel" v-model.trim="form.Tittel" maxlength="100" v-validate="'max:50'"/>

                <TheTextInput containerClassName="cell small-9 large-5" label="Fornavn" name="Fnavn" v-model.trim="form.Fnavn" maxlength="50" :required="!form.Bedrift" v-validate="fornavnRule"/>
                <TheTextInput containerClassName="cell large-5" label="Etternavn" name="Enavn" v-model.trim="form.Enavn" maxlength="50" :required="!form.Bedrift" v-validate="etternavnRule"/>

                <TheTextInput containerClassName="cell large-6" label="E-post" name="Email" v-model.trim="form.Email" v-validate="'email|kundeEmailUnique'">
                  <label slot="label" slot-scope="props" :for="props.id">
                    {{props.label}} <span v-if="emailcheck"> søker...</span>
                  </label>
                </TheTextInput>

                <div class="cell large-6">
                  <label for="Fodt">Fødselsdato</label>
                  <div class="input-container date" :class="{'form-error': errors.has('Fodt')}">
                    <b-datepicker
                      :show-week-number="false"
                      :editable="false"
                      :first-day-of-week="1"
                      v-model="form.Fodt"
                      name="Fodt"
                      placeholder="Vis kalender..."
                      icon="calendar-today"
                      ref="Fodt"
                      id="Fodt">
                      <button class="button disabled" v-if="!form.Fodt" @click.prevent="$refs.Fodt.toggle()"><span>Slett dato</span></button>
                      <button class="button" v-else @click.prevent="form.Fodt = null"><span>Slett dato</span></button>
                    </b-datepicker>
                    <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                    <span class="form-error-label" v-if="errors.has('Fodt')">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      {{errors.first('Fodt')}}
                    </span>
                  </div>
                </div>

                <div class="large-12">
                  <div class="divider"></div>
                  <div class="form-line-container">
                    <div class="grid-x form-line border">
                      <div class="cell auto">Mobil *</div>

                      <ThePhoneInput containerClassName="cell large-6" name="Mobil" :hideLabel="true" v-model.trim="form.Mobil" maxlength="20" v-validate="'required|max:20'"/>

                      <div class="cell shrink">
                        <a href="javascript:;" class="button action input-action glyph glyph-only delete-form-line disabled"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg></a>
                      </div>
                    </div>

                    <div v-for="item in phoneChoosen" v-bind:key="item.key" class="grid-x form-line border">
                      <div class="cell auto">
                        {{item.label}}
                      </div>

                      <ThePhoneInput containerClassName="cell large-6" :name="item.key" :hideLabel="true" v-model.trim="item.value" maxlength="20" v-validate="'max:20'"/>

                      <div class="cell shrink">
                        <a href="javascript:;" @click="delPhoneItem(item)" class="button action input-action glyph glyph-only delete-form-line"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg></a>
                      </div>
                    </div>

                    <div class="grid-x" v-if="getPhoneLinesOptions.length > 0">
                      <div class="cell large-12">
                        <span class="button-container has-popover" :class="{'popover-active': phonePopoverActive}" @click="togglePhonePopover()">
                          <span class="button action glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg> <span>Legg til telefonnummer</span></span>
                          <span class="popover align-x-center align-y-top medium">
                            <ul>
                              <li v-for="item in getPhoneLinesOptions" v-bind:key="'add-' + item.key">
                                <a class="add-form-line popover-form-line" href="javascript:;" @click="addPhoneItem(item)"><span>{{item.label}}</span></a>
                              </li>
                            </ul>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="scroll-section" id="kunde-edit-section-3">
            <h2>Fakturaadresse</h2>

            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <div class="cell large-12" v-if="edit">
                  <div class="card" v-if="!kunde.kundeadresse || kunde.kundeadresse.length < 1">
                    <h4>Nåværende lagret adresse</h4>
                    <dl>
                      <dt>Adresse1</dt>
                      <dd>{{kunde.Adresse1}}</dd>
                      <dt>Adresse2</dt>
                      <dd>{{kunde.Adresse2}}</dd>
                      <dt>Adresse3</dt>
                      <dd>{{kunde.Adresse3}}</dd>
                      <dt>Postnr / Poststed</dt>
                      <dd>{{kunde.Postnr}} / {{kunde.Poststed}}</dd>
                    </dl>
                  </div>
                </div>

                <TheTextInput containerClassName="cell large-12" label="Adressefelt 1" name="adresseFaktura-Adresse" v-model.trim="adresseFaktura.Adresse" maxlength="75" required v-validate="'required|max:75'"/>
                <TheTextInput containerClassName="cell large-12" label="Adressefelt 2" name="adresseFaktura-Adresse2" v-model.trim="adresseFaktura.Adresse2" maxlength="75" v-validate="'max:75'"/>
                <TheTextInput containerClassName="cell small-5 large-4" label="Postnummer" name="adresseFaktura-Postnr" v-model.trim="adresseFaktura.Postnr" required :maxlength="adresseFaktura.Landkode === 'NO' ? '4' : '10'" v-validate="{ required: true, max: adresseFaktura.Landkode === 'NO' ? '4' : '10' }"/>
                <TheTextInput containerClassName="cell small-7 large-8" label="Poststed" name="adresseFaktura-Poststed" v-model.trim="adresseFaktura.Poststed" maxlength="75" required v-validate="'required|max:75'"/>

                <TheSelectInput v-model="adresseFaktura.Landkode" containerClassName="cell large-6" label="Land" name="adresseFaktura-Landkode" :items="instillinger.land" data-vv-validate-on="input" required v-validate="'required|min:1'">
                  <span slot="option" slot-scope="props">
                    {{props.option.val}}
                    <span v-if="props.option.key && props.option.val !== 'Laster...'">[{{props.option.key}}]</span>
                  </span>
                </TheSelectInput>

                <TheTextInput containerClassName="cell large-6" label="C/O" placeholder="Navn" name="adresseFaktura-Co" v-model.trim="adresseFaktura.Co" maxlength="75" v-validate="'max:75'"/>

                <div class="cell">
                  <div class="input-container checkbox">
                    <input type="checkbox" name="sameaddress" id="sameaddress" v-model="sameaddress">
                    <label for="sameaddress">Fakturaadresse og leveringsadresse er like.</label>
                    <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

          <div v-if="!sameaddress">
            <h2>Leveringsadresse</h2>
            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <TheTextInput containerClassName="cell large-12" label="Adressefelt 1" name="adresseLevering-Adresse" v-model.trim="adresseLevering.Adresse" maxlength="75" v-validate="'max:75'"/>
                <TheTextInput containerClassName="cell large-12" label="Adressefelt 2" name="adresseLevering-Adresse2" v-model.trim="adresseLevering.Adresse2" maxlength="75" v-validate="'max:75'"/>
                <TheTextInput containerClassName="cell small-5 large-4" label="Postnummer" name="adresseLevering-Postnr" v-model.trim="adresseLevering.Postnr" :maxlength="adresseLevering.Landkode === 'NO' ? '4' : '10'" v-validate="{ max: adresseLevering.Landkode === 'NO' ? '4' : '10' }"/>
                <TheTextInput containerClassName="cell small-7 large-8" label="Poststed" name="adresseLevering-Poststed" v-model.trim="adresseLevering.Poststed" maxlength="75" v-validate="'max:75'"/>

                <TheSelectInput v-model="adresseLevering.Landkode" containerClassName="cell large-6" label="Land" name="adresseLeveringLandkode" :items="instillinger.land">
                  <span slot="option" slot-scope="props">
                    {{props.option.val}}
                    <span v-if="props.option.key && props.option.val !== 'Laster...'">[{{props.option.key}}]</span>
                  </span>
                </TheSelectInput>

                <TheTextInput containerClassName="cell large-6" label="C/O" placeholder="Navn" name="adresseLevering-Co" v-model.trim="adresseLevering.Co" maxlength="75" v-validate="'max:75'"/>
              </div>
            </fieldset>
          </div>

          <div class="scroll-section" id="kunde-edit-section-4">
            <h2>Legitimasjon</h2>

            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <div class="cell small-12 large-6 medium-6">
                  <label for="Legtype">Legitimasjonstype</label>
                  <div class="select-container" :class="{ 'form-error': errors.has('Legtype') }">
                    <select id="Legtype" name="Legtype" v-model="form.Legtype" @change="$validator.validate('Legitimert'); form.Legitimert = false;">
                      <option v-for="option in instillinger.legitimasjon" v-bind:value="option.key" v-bind:key="option.key">{{option.val}}</option>
                    </select>
                    <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
                    <span class="form-error-label" v-if="errors.has('Legtype')">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      {{errors.first('Legtype')}}
                    </span>
                  </div>
                </div>
                <div class="cell small-12 large-6 medium-6">
                  <label>Legitimert <span v-if="form.Legtype">*</span></label>
                  <div class="radio-button-container" :class="{ 'form-error': errors.has('Legitimert') }">
                    <ul>
                      <li><input type="radio" :disabled="!form.Legtype" v-model="form.Legitimert" v-bind:value="false" name="Legitimert" id="ikke-legitimert" v-validate="{ included: form.Legtype ? ['true', true] : [] }"> <label for="ikke-legitimert">Nei</label></li>
                      <li><input type="radio" :disabled="!form.Legtype" v-model="form.Legitimert" v-bind:value="true" name="Legitimert" id="legitimert" checked> <label for="legitimert">Ja</label></li>
                    </ul>
                  </div>
                  <div class="cell small-12 large-12 medium-12" style="margin-top: -1.3rem;">
                    <div class="input-container" :class="{ 'form-error': errors.has('Legitimert') }">
                      <span class="form-error-label" v-if="errors.has('Legitimert')">
                        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                        Vennligst bekreft legitimasjonen
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="scroll-section" id="kunde-edit-section-5">
            <h2>Økonomi</h2>
            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <TheIntegerInput containerClassName="cell large-12" label="Kontonummer" name="Kontonr" v-model.trim="form.Kontonr" v-validate="'min:11|max:11|kundeKontonrValidation'"/>
                <TheTextInput containerClassName="cell large-6" label="SWIFT" name="Swift" v-model.trim="form.Swift" maxlength="40" v-validate="'max:40'"/>
                <TheTextInput containerClassName="cell large-6" label="IBAN" name="Iban" v-model.trim="form.Iban" maxlength="40" v-validate="'max:40'"/>
                <TheTextInput containerClassName="cell large-12" label="Betalingsinfo" name="Betalings_info" v-model.trim="form.Betalings_info" maxlength="255" v-validate="'max:255'"/>
                <TheDecimalInput containerClassName="cell small-6" symbol="%" label="Salær" name="Salar" v-model.trim="form.Salar" maxlength="10" v-validate="'max:10|decimal'"/>
                <TheDecimalInput containerClassName="cell small-6" symbol=kr label="Auksjonshonorar" name="Fotokostnad" v-model.trim="form.Fotokostnad" maxlength="10" v-validate="'max:10|decimal'"/>
              </div>
              <h2>Kredittkort</h2>
              <table>
                <tr>
                  <td>Kortnummer</td>
                  <td>Gyldighet</td>
                </tr>
                <tr v-for="card in kunde.kunde_netaxept_card" v-bind:value="card.id" v-bind:key="card.id">
                  <td>{{card.MaskedPan}}</td>
                  <td v-html="formatCreditDate(card.ExpiryDate)">{{card.ExpiryDate}}</td>
                </tr>
              </table>
            </fieldset>
          </div>

          <div class="scroll-section" id="kunde-edit-section-6">
            <h2>Vin</h2>
            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <div class="cell small-12 large-12 medium-12">
                  <label for="Utlevering">Utlevering</label>
                  <div class="select-container" :class="{ 'form-error': errors.has('Utlevering') }">
                    <select id="Utlevering" name="Utlevering" v-model="form.Vinfraktid">
                      <option v-for="option in instillinger.vinfrakt" v-bind:value="option.key" v-bind:key="option.key">{{option.val}}</option>
                    </select>
                    <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="scroll-section" id="kunde-edit-section-7">
            <h2>Know Your Customer</h2>
            <fieldset class="card">
              <div class="grid-x grid-padding-x">
                <div class="cell">
                  <ul class="switch-list">
                    <TheSwitchListSwitchInput v-model="form.kyc_sent" labelTrue="The KYC form was sent to the customer" labelFalse="The KYC form was sent to the customer"/>
                  </ul>
                </div>

                <div class="cell large-6">
                  <label for="kyc_exceeded">KYC exceded amount</label>
                  <div class="input-container date" :class="{'form-error': errors.has('kyc_exceeded')}">
                    <b-datepicker
                      :show-week-number="false"
                      :editable="false"
                      :first-day-of-week="1"
                      :disabled="true"
                      v-model="form.kyc_exceeded"
                      name="kyc_exceeded"
                      placeholder="Vis kalender..."
                      icon="calendar-today"
                      ref="kyc_exceeded"
                      id="kyc_exceeded">
                      <button class="button disabled" v-if="!form.kyc_exceeded" @click.prevent="$refs.kyc_exceeded.toggle()"><span>Slett dato</span></button>
                      <button class="button" v-else @click.prevent="form.kyc_exceeded = null"><span>Slett dato</span></button>
                    </b-datepicker>
                    <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                    <span class="form-error-label" v-if="errors.has('kyc_exceeded')">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      {{errors.first('kyc_exceeded')}}
                    </span>
                  </div>
                </div>

                <div class="cell large-6">
                  <label for="kyc_filled">KYC form filled</label>
                  <div class="input-container date" :class="{'form-error': errors.has('kyc_filled')}">
                    <b-datepicker
                      :show-week-number="false"
                      :editable="false"
                      :first-day-of-week="1"
                      v-model="form.kyc_filled"
                      name="kyc_filled"
                      placeholder="Vis kalender..."
                      icon="calendar-today"
                      ref="kyc_filled"
                      id="kyc_filled">
                      <button class="button disabled" v-if="!form.kyc_filled" @click.prevent="$refs.kyc_filled.toggle()"><span>Slett dato</span></button>
                      <button class="button" v-else @click.prevent="form.kyc_filled = null"><span>Slett dato</span></button>
                    </b-datepicker>
                    <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                    <span class="form-error-label" v-if="errors.has('kyc_filled')">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      {{errors.first('kyc_filled')}}
                    </span>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import KundeService from '@/services/KundeService'
import DummyCache from '@/plugins/dummy-cache.js'
import InstillingerService from '@/services/InstillingerService'
import bus from '@/plugins/event-bus'
import moment from 'moment'

export default {
  name: 'KundeCardForm',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    kunde: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      edit: false,
      form: {},
      sectionErrors: {},
      sameaddress: true,
      adresseFaktura: {},
      adresseLevering: {},
      instillinger: {
        land: [],
        legitimasjon: [],
        bruker: [],
        sprak: [
          { key: '', val: '- Velg språk -' },
          { key: 'nor-NO', val: 'Norsk' },
          { key: 'eng-GB', val: 'Engelsk' }
        ],
        vinfrakt: []
      },
      loading: true,
      emailcheck: false,
      postnrList: [],
      phoneOptions: [
        { key: 'Tlfarbeid', label: 'Arbeide', value: null },
        { key: 'Tlfprivat', label: 'Privat', value: null }
      ],
      phoneChoosen: {},
      phonePopoverActive: false,
      VinKunde: false
    }
  },
  computed: {
    firmaNavnRule: function () {
      return this.form.Bedrift ? 'required|max:100' : ''
    },
    fornavnRule: function () {
      return this.form.Bedrift ? 'max:50|' : 'required|max:50'
    },
    etternavnRule: function () {
      return this.form.Bedrift ? 'max:50|customNameCheck' : 'required|max:50|customNameCheck'
    },
    fullnameLength: function () {
      const fullname = this._.trim(this.form.Fnavn) + ' ' + this._.trim(this.form.Enavn)

      return fullname.length
    },
    katalogInfoRule: function () {
      return Number(this.form.Katalog || 0) === 1 ? 'required|max:255' : 'max:255'
    },
    getPhoneLinesOptions: function () {
      let retval = []

      this.phoneOptions.forEach((item) => {
        if (!this.phoneChoosen.hasOwnProperty(item.key)) {
          retval.push(item)
        }
      })

      return retval
    },
    hasSperretAccess: function () {
      return this.hasAccess('expert')
    }
  },
  mounted () {
    // Listen to submit form event from parent - cus button is in parent
    bus.$on('kunde-form-submit', () => this.handleSubmit())
  },
  created () {
    // Must turn off the event listener in case it is already there...
    bus.$off('kunde-form-submit')

    // Set form to loading
    this.setFormLoading(true)

    // Edit mode?
    this.edit = !!this.kunde.Kundenr

    // if (this.edit && this.kunde.AktivertV) {
    //   this.VinKunde = true
    // } else if (this.$store.getters.getUser.vin) {
    //   // Perhaps check for this.$store.getters.getUser.Avdelingsid === 2
    //   this.VinKunde = true
    // }

    var vm = this
    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.phonePopoverActive = false
      }
    })

    // Add the kunde email unique rule to our validator
    this.$validator.extend('kundeEmailUnique', {
      validate: this.uniqueEmailCheck,
      getMessage: (field, params, data) => data ? data.message : 'Kunde med denne epost finnes allerede'
    })

    // Add the name length check rule to our validator
    this.$validator.extend('customNameCheck', {
      validate: this.customNameCheckValidator,
      getMessage: (field, params, data) => data ? data.message : 'Kundenavn får ikke ha mer enn 50 tegn.'
    })

    // Add the kunde kontonummer unique rule to our validator
    this.$validator.extend('kundeKontonrValidation', {
      validate: this.kontonrValidation,
      getMessage: (field, params, data) => data ? data.message : 'Virker som at Kontonummer ikke er gyldig'
    })

    this.loadVinfrakt()

    // Create an emails cache container, so we don't have to do api requests if same email is sent tvice...
    this.emailsCache = new DummyCache()

    // Load data needed in the form
    this.fetch()
  },
  watch: {
    'form.Katalog': function (newVal, oldVal) {
      if (!newVal && oldVal !== undefined) {
        this.form.KatalogInfo = ''
      }
    },
    'form.Fnavn': function (newVal, oldVal) {
      if (newVal && oldVal !== undefined) {
        this.$validator.validate('Enavn')
      }
    },
    'form.Enavn': function (newVal, oldVal) {
      if (newVal && oldVal !== undefined) {
        this.$validator.validate('Enavn')
      }
    },
    'kunde': function (newVal) {
      if (newVal !== undefined) {
        // If kunde was updated, we need to reload the data - i.e. the addresses.
        this.makeFormItem()
      }
    },
    'form.Landkode': function (newVal, oldVal) {
      this.$validator.validate('Kontonr')
    },
    'adresseFaktura.Postnr': function (newVal, oldVal) {
      if (this.adresseFaktura.Landkode === 'NO') {
        // Skip - if on load and not a norway
        if (newVal !== undefined) {
          if (!newVal || newVal.length !== 4) {
            this.adresseFaktura.Poststed = ''
          } else {
            let found = this.postnrList.find(x => '' + x.key === newVal)

            if (found) {
              this.adresseFaktura.Poststed = found.val
            } else if (oldVal !== undefined) {
              this.adresseFaktura.Poststed = ''
            }
          }
        }
      }
    },
    'adresseLevering.Postnr': function (newVal, oldVal) {
      if (this.adresseLevering.Landkode === 'NO') {
        if (newVal !== undefined && !this.sameaddress) {
          if (!newVal || newVal.length !== 4) {
            this.adresseLevering.Poststed = ''
          } else {
            let found = this.postnrList.find(x => '' + x.key === newVal)

            if (found) {
              this.adresseLevering.Poststed = found.val
            } else if (oldVal !== undefined) {
              this.adresseLevering.Poststed = ''
            }
          }
        }
      }
    },
    'errors.items': function () {
      let vm = this
      let jq = window.jQuery

      // console.log(this.errors.items)
      setTimeout(() => {
        // Reset errors
        vm.sectionErrors = {}

        if (jq('.form-error').length) {
          jq('.form-error').each(function () {
            let section = jq(this).closest('.scroll-section')

            vm.sectionErrors[section.attr('id')] = jq('.form-error', section).length
          })
        }
      })
    },
    'form.Sperret': function (newVal, oldVal) {
      if (newVal === 'T') {
        if (oldVal === 'F') {
          this.showSperretConfirm()
        }

        // Reset all validation errors
        this.$validator.reset()

        // Pause validation (i.e. skip validation for now)
        this.$validator.pause()
      } else if (oldVal !== undefined) {
        // Resume validation
        this.$validator.resume()

        // Run all validation - but we skip that at this moment
        // this.$validator.validateAll()
      }
    }
  },
  methods: {
    customNameCheckValidator: function (value) {
      return new Promise(resolve => {
        // Check length
        // console.log(this.fullnameLength)
        if (this.fullnameLength > 50) {
          return resolve({valid: false, data: {message: 'Kundenavn får ikke ha mer enn 50 tegn.'}})
        }

        return resolve({valid: true})
      })
    },
    showSperretConfirm: function () {
      var vm = this

      this.openConfirm(
        'Er du sikker på du vil sperre kunden?',
        'Det betyr at kunden ikke lenger kan by på nettauksjonen, eller gi forhåndsbud på nett på klassisk auksjon. Det vil heller ikke bli mulig å opprette auksjonsspade eller registrere seg for telefonbud.',
        'Ja',
        'Nei',
        function () {
          vm.form.Sperret = 'T'
          vm.closeModal()
        },
        function () {
          vm.form.Sperret = 'F'
          vm.closeModal()
        }
      )
    },
    togglePhonePopover: function () {
      this.phonePopoverActive = !this.phonePopoverActive
    },
    addPhoneItem: function (item) {
      this.$set(this.phoneChoosen, item.key, { key: item.key, label: item.label, value: null })

      // Now set new element in focus
      setTimeout(function () {
        window.jQuery('input[name=' + CSS.escape(item.key) + ']').focus()
      })
    },
    delPhoneItem: function (item) {
      this.$delete(this.phoneChoosen, item.key)
    },
    makeFormItem: function () {
      let defaults = {
        Bedrift: false,
        Sperret: 'F',
        SendLagerleieinfo: 1,
        Arsavtale: 0,
        AktivertK: null,
        AktivertV: null,
        AktivertN: null,
        Landkode: 'NO',
        Legtype: 0,
        Legitimert: false,
        Leverandor: 'F',
        Sprak: 'nor-NO',
        Brukerid: 0,
        Vipps: false
      }

      // Special to set Brukerid based on logged in user or previous saved kundeansvarlig
      if (this.edit) {
        defaults.Brukerid = this.kunde.kundeansvarlig ? this.kunde.kundeansvarlig.Brukerid : 0
      } else {
        defaults.Brukerid = this.$store.getters.getUser.Brukerid
        defaults.Salar = 20
      }

      // Apply default values to Kunde
      this.$helpers.setObjectValues(defaults, this.kunde)

      // Clone kunde to the form object
      this.form = this._.cloneDeep(this.kunde)

      if (this.form.Fodt) {
        this.form.Fodt = new Date(Date.parse(this.form.Fodt))
      }

      if (this.form.kyc_exceeded) {
        this.form.kyc_exceeded = new Date(Date.parse(this.form.kyc_exceeded))
      }

      if (this.form.kyc_filled) {
        this.form.kyc_filled = new Date(Date.parse(this.form.kyc_filled))
      }

      // Prep addresse
      this.adresseFaktura = this._.find(this.kunde.kundeadresse, ['Type', 'faktura']) || {}
      this.adresseLevering = this._.find(this.kunde.kundeadresse, ['Type', 'levering']) || {}

      // Set default NO as land if not already set
      if (!this.adresseFaktura.Landkode) {
        this.adresseFaktura.Landkode = 'NO'
      }

      if (!this.adresseLevering.Landkode) {
        this.adresseLevering.Landkode = 'NO'
      }

      // Check if it is same address / for the checkbox
      if (this._.isEmpty(this.adresseLevering)) {
        this.sameaddress = true
      } else {
        this.sameaddress = this._.isEqual(
          this._.omit(this.adresseFaktura, ['id', 'Type']),
          this._.omit(this.adresseLevering, ['id', 'Type'])
        )
      }

      // Add phonenumbers
      this.phoneOptions.forEach((item) => {
        if (this.form.hasOwnProperty(item.key) && this.form[item.key]) {
          this.$set(this.phoneChoosen, item.key, { key: item.key, label: item.label, value: this.form[item.key] })
        }
      })

      // if (this.phoneChoosen === {}) {
      //   this.$set(this.phoneChoosen, this.phoneOptions[0].key, { key: this.phoneOptions[0].key, label: this.phoneOptions[0].label, value: null })
      // }
    },
    fetch: function () {
      this.loading = true

      // Add a temp item in all dropdowns, where it show that it is loading...
      this.instillinger.land.unshift({key: this.form.Landkode, val: 'Laster...'})
      this.instillinger.legitimasjon.unshift({key: this.form.Legtype, val: 'Laster...'})
      this.instillinger.bruker.unshift({key: this.form.Brukerid, val: 'Laster...'})

      KundeService.loadFormDropdowns()
        .then((data) => {
          this.instillinger.land = data.land
          this.instillinger.land.unshift({key: null, val: '- Velg land -'})

          this.instillinger.legitimasjon = data.legitimasjon
          this.instillinger.legitimasjon.unshift({key: 0, val: '- Velg legitimasjonstype -'})

          this.instillinger.bruker = data.bruker
          this.instillinger.bruker.unshift({key: 0, val: '- Ingen kundeansvarlig -'})
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.loading = false

          this.makeFormItem()

          // Now submittable again
          this.setFormLoading(false)
        })

      InstillingerService('postreg').dropdown()
        .then((response) => {
          this.postnrList = response.data
        })
        .catch((e) => {
          console.log(e)
          this.postnrList = []
        })
    },
    addAddressesToFormData: function () {
      // Prep addresse
      this.form.kundeadresse = []

      // We have no faktura - so create it
      if (this._.isEmpty(this.adresseFaktura) || !this.adresseFaktura.Type) {
        this.adresseFaktura.Type = 'faktura'

        if (this.kunde.Kundenr) {
          this.adresseFaktura.Kundenr = this.kunde.Kundenr
        }
      }

      // We have no levering - so create it
      if (this._.isEmpty(this.adresseLevering) || !this.adresseLevering.Type) {
        this.adresseLevering.Type = 'levering'

        if (this.kunde.Kundenr) {
          this.adresseLevering.Kundenr = this.kunde.Kundenr
        }
      }

      // Same address clicked
      if (this.sameaddress) {
        this.adresseLevering = this._.merge(this.adresseLevering || {}, this._.omit(this.adresseFaktura, ['id', 'Type']))
      }

      this.form.kundeadresse.push(this.adresseFaktura)
      this.form.kundeadresse.push(this.adresseLevering)
    },
    addPhonesToFormData: function () {
      Object.keys(this.phoneChoosen).forEach((key) => {
        this.form[key] = this.phoneChoosen[key].value
      })
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            this.save()
          }
        })
    },
    save: function () {
      let kundenr = this.kunde.Kundenr || null

      // Add the addresses to the form data
      this.addAddressesToFormData()
      this.addPhonesToFormData()

      // Fix dates
      let data = this._.clone(this.form)

      if (data.Fodt) {
        const df = new Date(Date.parse(data.Fodt))
        data.Fodt = moment(df).format('YYYY-MM-DD')
      }

      KundeService.save(kundenr, data)
        .then((response) => {
          this.$helpers.showSuccessAlert('Kunde er lagret')

          if (!kundenr) {
            this.$router.push({ name: 'KundeCard', params: {kunde_id: response.data.Kundenr} })
          } else {
            bus.$emit('kunde-updated', response.data)
          }
          setTimeout(this.makeFormItem, 100)
        })
        .catch((error) => {
          // Put API errors into the error container
          this.$helpers.sendApiErrorsToValidator(error, this.errors)

          // Check if new errors appeared
          if (this.errors.any()) {
            this.$validator.resume()
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst prøv igjen', 2500)
          }
        })
        .then(() => {
          this.setFormProcessing(false)
        })
    },
    uniqueEmailCheck: function (value) {
      value = value.toLowerCase()
      this.form.Email = value
      return new Promise(resolve => {
        // Compare to original value first, if save we allow it
        if (this.kunde.Email && value === this.kunde.Email.toLowerCase()) {
          resolve({valid: true})
          return
        }

        // Start email check
        this.emailcheck = true
        let promise = null

        // See if we have a cached email
        if (!(promise = this.emailsCache.get(value))) {
          promise = KundeService.findByEmail(value)
          this.emailsCache.set(value, promise)
        }

        // Now do the resolve/reject logic
        promise
          .then((response) => {
            if (response.data && response.data.Email.toLowerCase() === value) {
              resolve({valid: false, data: {message: 'Kunde med denne epost finnes allerede'}})
            } else {
              resolve({valid: true})
            }
          })
          .catch(() => {
            resolve({valid: true})
          })
          .then(() => {
            this.emailcheck = false
          })
      })
    },
    kontonrValidation: function (value) {
      console.log('Validation', this.form.Landkode)
      return new Promise(resolve => {
        if (!value) {
          resolve({valid: false, data: {message: 'Kontonummer er påkrevd'}})
        } else if (value.length !== 11) {
          resolve({valid: false, data: {message: 'Kontonummeret må bestå av 11 siffer'}})
        } else if (this.form.Landkode === 'NO') {
          // Check modulus 11
          if (!this.checkModulus11(value)) {
            resolve({valid: false, data: {message: 'Kontonummeret er ikke gyldig'}})
          } else {
            resolve({valid: true})
          }
        } else {
          resolve({valid: true})
        }
      })
    },
    newsletter: function (type) {
      alert('Ennå ikke implementert')
    },
    formatCreditDate: function (date) {
      let value = Array.from(date)
      return value[2] + value[3] + '/' + value[0] + value[1]
    },
    loadVinfrakt: function () {
      InstillingerService('vinfrakt').dropdown()
        .then((response) => {
          this.instillinger.vinfrakt = response.data
        })
        .catch((e) => {
          console.log(e)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardForm.vue